"use strict";

define('rs/checklist/checklist.controller',['vertebrae', './checklist.view', 'e3-form', 'rs/models/template', 'rs/models/document', 'rs/models/docstore', 'rs/helper'], function (Vertebrae, ChecklistView, E3Form, Template, Document, Docstore, RSHelper) {
  var ChecklistController = Vertebrae.Controller.extend({
    view: ChecklistView,
    properties: ['document', 'checklists', 'selectedChecklist', 'currentChecklistEditable', 'form', 'formView', 'appController'],
    observes: {
      'window-resize': 'resize'
    },
    initialize: function initialize(doc, checklists, appController) {
      this.setDocument(doc);
      this.setChecklists(checklists);
      this.setAppController(appController);
      this.loadChecklist(checklists[0]);
      this.listenTo(this, 'change:entity:value', this.updateFormEntityValue);
      this.saveFormAnswerData = _.debounce(_.bind(this.saveFormAnswerData, this), 100);
      this._super.apply(this, arguments);
    },
    getRedactorOptions: function getRedactorOptions() {
      return {
        changeCallback: function changeCallback() {},
        uploadImageUrl: Docstore.getRelativeImageURL(this.getDocument().getId())
      };
    },
    loadChecklist: function loadChecklist(checklistDoc) {
      var that = this;
      function getJson(id, rev) {
        return Template.requestFormTemplate(id, rev).then(function (form) {
          return JSON.parse(form.json);
        });
      }
      var form = this.getForm();
      if (form && _.isFunction(form.destroy)) {
        this.stopListening(form);
        form.destroy();
      }
      form = E3Form.Factory.start().template(getJson(checklistDoc.getTemplateId(), checklistDoc.getTemplateRevisionNumber())).progressiveDisclosure(true).answers(checklistDoc.requestAnswerData()).build().bind(this);
      this.setCurrentChecklistEditable(this.canEditChecklist(checklistDoc));
      this.setSelectedChecklist(checklistDoc);
      this.setForm(form, {
        promise: true
      });
      return form;
    },
    viewIsAvailable: function viewIsAvailable() {
      Promise.resolve(this.getForm()).bind(this).then(function () {
        var view = E3Form.Views.Form.setup(this.getView().getFormContainer(), this);
        this.setFormView(view);
        this.refreshFormView();
      }).tap(function () {
        if (this.getAppController().store.get('document.edit.checklist')) {
          this.open();
        }
        this.resize();
      });
    },
    refreshFormView: function refreshFormView() {
      var view = this.getFormView();
      view.render();
      view.setRendered();
      if (!this.getCurrentChecklistEditable()) {
        view.disable();
      } else {
        view.enable();
      }
      this.getView().refreshChecklistActions();
      this.listenTo(this.getForm(), "change:entity:value", this.formEntityValueDidChange);
    },
    requestSelectChecklist: function requestSelectChecklist(checklist) {
      this.loadChecklist(checklist).bind(this).tap(function () {
        this._userAnswerChange = false;
        this.refreshFormView();
      })["finally"](this.showLoading());
    },
    saveAnswer: function saveAnswer(formEntity, doc) {
      this._answersToSave = this._answersToSave || [];
      if (!_.isUndefined(formEntity.getValue())) {
        this._answersToSave.push({
          id: formEntity.getId(),
          value: formEntity.getValue(),
          section: formEntity.getSection().getId(),
          document: doc.getId()
        });
      }
    },
    saveCurrentFormAnswers: function saveCurrentFormAnswers() {
      var doc = this.getSelectedChecklist(),
        form = this.getForm(),
        answers = null,
        self = this;
      return Promise.map(form.getSections(), function (section) {
        answers = self.getSerializedSectionAnswers(section);
        return Document.saveAnswerData(doc.getId(), section.getId(), answers);
      }).bind(this).tap(function () {
        this._userAnswerChange = false;
        this.getView().refreshChecklistActions();
      })["finally"](this.showLoading());
    },
    getSerializedSectionAnswers: function getSerializedSectionAnswers(section) {
      var form = this.getForm(),
        answers = form.serializeAnswers(section),
        entity = null;
      return _.filter(answers, function (answer) {
        entity = form.formEntityMap[answer.id];
        return entity.type != 'attachmentpoint' && entity.type != 'attachment';
      });
    },
    saveFormAnswerData: function saveFormAnswerData() {
      var answersByDoc = _.groupBy(this._answersToSave, 'document');
      _.each(answersByDoc, function (docAnswers, docId) {
        var answersBySection = _.groupBy(docAnswers, 'section');
        for (sectionId in answersBySection) {
          var answerGroup = answersBySection[sectionId],
            foundAnswerMap = {},
            data = [];
          for (var i = answerGroup.length - 1, item; i >= 0; i--) {
            item = answerGroup[i];
            if (!foundAnswerMap[item.id]) {
              foundAnswerMap[item.id] = true;
              data.push({
                id: item.id,
                value: item.value
              });
            }
          }
          Document.saveAnswerData(docId, sectionId, data);
        }
      });
      this._userAnswerChange = false;
      this._answersToSave = [];
    },
    showLoading: function showLoading() {
      RSHelper.hideLoading();
      RSHelper.showLoading(this.getView().$el, false, true);
      return function () {
        RSHelper.hideLoading();
      };
    },
    formEntityValueDidChange: function formEntityValueDidChange(formEntity) {
      if (this._userAnswerChange) {
        this.saveAnswer(formEntity, this.getSelectedChecklist());
      }
    },
    updateFormEntityValue: function updateFormEntityValue(ev) {
      if (this.getCurrentChecklistEditable()) {
        if (!this._userAnswerChange) {
          this._userAnswerChange = true;
          this.getView().refreshChecklistActions();
        }
        ev.entity.setValue(ev.value);
      } else {
        ev.entity.reloadValue();
      }
    },
    getChecklistEditableState: function getChecklistEditableState() {
      return this.getCurrentChecklistEditable() && this._userAnswerChange;
    },
    canEditChecklist: function canEditChecklist(c) {
      var self = this.getAppController().getUser().getPerson(),
        rps = c.getResponsiblePersons();
      if (this.getDocument().finalized) {
        return false;
      }
      for (var i = 0, len = rps.length, p; i < len; i++) {
        p = rps[i];
        if (p.getId() == self.getId()) {
          return true;
        }
      }
      return false;
    },
    getRootFormEntity: function getRootFormEntity() {
      return this.getForm().getSections()[0];
    },
    getFormEntityViewByType: function getFormEntityViewByType(type) {
      return E3Form.Views.types[type];
    },
    getTemplateProperties: function getTemplateProperties() {
      var cls = this.getChecklists() || [];
      var checklistMap = _.map(cls, function (m) {
        return {
          id: m.id,
          name: m.getResponsiblePersons()[0].getDisplayName(),
          type: m.getTemplateType()
        };
      });
      return {
        multipleChecklists: cls.length > 1,
        checklists: checklistMap,
        selChecklist: this.getSelectedChecklist().getId()
      };
    },
    toggleChecklist: function toggleChecklist() {
      if (this.getView().isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    open: function open() {
      this.getAppController().store.set('document.edit.checklist', true);
      this.getView().open();
    },
    close: function close() {
      var view = this.getView();
      this.getAppController().store.set('document.edit.checklist', false);
      if (this.getChecklistEditableState()) {
        this.saveCurrentFormAnswers().tap(function () {
          view.close();
        });
      } else {
        view.close();
      }
    },
    resize: function resize() {
      $('textarea').each(function () {
        if (this.scrollHeight > 0) {
          $(this).height(this.scrollHeight - 10);
          $(this).css('transition', 'all 0.1s ease-out');
        }
      });
      this.getView().resize();
    }
  });
  return ChecklistController;
});

